"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _link = _interopRequireDefault(require("../../../core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null, "Competition");
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, "Date");
class EntriesTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getCompLink", day => {
      if (!day.isPublished && !day.isAdministratedByUser) return day.competitionName;
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        to: '/year/' + this.props.yearID + '/competition/' + day.competitionSlug
      }, day.competitionName);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, _ref2, this.props.divsInUse.map(div => /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left",
      key: div.tierRef
    }, div.description)))), /*#__PURE__*/_react.default.createElement("tbody", null, this.props.stats.map(day => /*#__PURE__*/_react.default.createElement("tr", {
      key: day.competitionDayID
    }, /*#__PURE__*/_react.default.createElement("td", null, day.competitionName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(day.raceDate, 'D MMM YY')), this.props.divsInUse.map(div => /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left",
      key: div.tierRef
    }, day.entriesByDivisionID[div.tierRef]))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = EntriesTable;